import axios from 'axios'
import {toData} from "./util";

export function searchProducts(query, subsidiaryId): Promise {
  return axios.get(`/api/products/search?query=${query}&subsidiaryId=${subsidiaryId}`).then(toData)
}

export function searchProductsDashboard(query, subsidiaryId): Promise {
  return axios.get(`/api/products/dashboard/search?query=${query}&subsidiaryId=${subsidiaryId}`).then(toData)
}

export function searchLicenseActivePercentageByProductEan(query): Promise {
  return axios.get(`/api/products/dashboard/getActiveLicensesPercentageByProductEan?query=${query}`).then(toData)
}

export function getProduct(id, subsidiaryId): Promise {
  return axios.get(`/api/products/${id}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function updateProduct(product, subsidiaryId): Promise {
  return axios.put(`/api/products/${product.id}?subsidiaryId=${subsidiaryId}`, product).then(toData)
}

export function getRevisions(id): Promise {
  return axios.get(`/api/revisions/product/${id}/contentReferences`).then(toData)
}
